import { Outlet } from "react-router-dom";

const DebugLayout = () => {
  return <Outlet />;
};

export default DebugLayout;
